import { render, staticRenderFns } from "./CompaniesArchive.vue?vue&type=template&id=18fb777e"
import script from "./CompaniesArchive.vue?vue&type=script&lang=js"
export * from "./CompaniesArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports